// npm imports
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// components imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr } from "@revvsales/components";
// action imports
import {
  deleteAssetStatusAction,
  deleteAssetTagAction,
} from "../../../actions/AssetActions/assetActions";

// internal imports
import { GlobalUtils, AmplitudeUtils } from "../../../utils";

import { ASSET, EVENTS } from "../../../constants";

// destructuring
const { amplitudeLogEvent } = AmplitudeUtils;
const { handleApiErrMsg } = GlobalUtils;
const { COLORS } = ASSET;

class AddEditDropdown extends Component {
  state = {
    editListItems: [],
    colorIndex: -1,
    newStatus: {
      name: "",
      sequence: 100,
      color: "#888888",
      localId: "new-item",
    },
    newTag: {
      name: "",
      sequence: 100,
      localId: "new-item",
    },
  };

  componentDidMount() {
    // add close event listner
    document.addEventListener("click", this.handleClickOutside);
    // set props for the same
    const { listItems } = this.props;
    this.setState({
      editListItems: listItems,
    });
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  isEqual = (array1, array2) => {
    if (array2.length !== array1.lenght) {
      return false;
    }
    for (let i = 0; i < array1.length; i += 1) {
      if (array1[i].id !== array2.id) {
        return false;
      }
    }
    return true;
  };

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  handleClickOutside = event => {
    if (
      this.wrapperRef &&
      event.target &&
      event.target.dataset &&
      this.wrapperRef.id !== event.target.dataset.id &&
      !this.wrapperRef.contains(event.target)
    ) {
      this.props.closeAddEditContainer();
    }
  };

  handleItemEdit = (event, index) => {
    event.preventDefault();
    const { editListItems } = this.state;
    let colorIndex = -1;
    const newEditItems = editListItems.map((item, ind) => {
      if (ind !== index) {
        return item;
      }
      colorIndex = ind;
      return { ...item, name: event.target.value, isChange: true };
    });
    this.setState({ editListItems: newEditItems, colorIndex });
  };

  handleChangeColor = newColor => {
    const { colorIndex, editListItems, newStatus } = this.state;
    if (colorIndex === -1) {
      this.setState({
        newStatus: {
          ...newStatus,
          color: newColor,
        },
      });
    } else if (colorIndex >= 0 && colorIndex < editListItems.length) {
      this.setState({
        editListItems: editListItems.map((item, index) => {
          if (index === colorIndex) {
            return { ...item, color: newColor, isChange: true };
          }
          return item;
        }),
      });
    }
  };

  handleColorIndex = index => {
    this.setState({ colorIndex: index });
  };

  getErrorMessage = (err, type) => {
    if (
      err &&
      err.response &&
      err.response.data &&
      err.response.data.code === "REV-0008"
    ) {
      let message = "Cannot Delete Tag! It is being used somewhere else";
      if (type === "status") {
        message = "Cannot Delete Status! It is being used somewhere else";
      }
      return {
        response: {
          data: {
            message,
          },
        },
      };
    }
    return err;
  };

  removeItem = index => {
    const { editListItems } = this.state;
    const { type } = this.props;
    const deletedItem = editListItems.find((item, i) => i === index);
    if (deletedItem.id) {
      if (type === "status") {
        this.props
          .deleteAssetStatus(deletedItem.id)
          .then(() => {
            const newEditItems = editListItems.filter((item, i) => i !== index);
            this.setState({ editListItems: newEditItems, colorIndex: -1 });
          })
          .catch(err => {
            // toaster implement here
            Toastr.showToastr({
              type: "failure",
              message: handleApiErrMsg(this.getErrorMessage(err, type)),
              timeout: 3000,
            });
          });
      } else {
        this.props
          .deleteAssetTag(deletedItem.id)
          .then(() => {
            const newEditItems = editListItems.filter((item, i) => i !== index);
            this.setState({ editListItems: newEditItems, colorIndex: -1 });
          })
          .catch(err => {
            // toaster implement here
            Toastr.showToastr({
              type: "failure",
              message: handleApiErrMsg(this.getErrorMessage(err)),
              timeout: 3000,
            });
          });
      }
    } else {
      // delete new item
      const newEditItems = editListItems.filter((item, i) => i !== index);
      this.setState({ editListItems: newEditItems, colorIndex: -1 });
    }
  };

  rearrange = () => {
    //
  };

  dragStart = e => {
    //
    this.dragged = e.currentTarget;
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/html", this.dragged);
  };

  dragEnd = () => {
    const { editListItems } = this.state;
    const data = [...editListItems];
    const from = Number(this.dragged.dataset.id);
    const to = Number(this.over.dataset.id);
    if (!Number.isNaN(from) && !Number.isNaN(to)) {
      const temp = data[from];
      data[from] = data[to];
      data[to] = temp;
      this.setState({ editListItems: data });
    }
  };

  dragOver = e => {
    //
    e.preventDefault();
    this.over = e.target;
  };

  keyPressed = e => {
    if (e.key === "Enter") {
      this.addToList();
    }
  };

  handleNewItemNameChange = e => {
    const { newStatus, newTag } = this.state;
    const { type } = this.props;
    if (type === "status") {
      this.setState({
        newStatus: { ...newStatus, name: e.target.value },
        colorIndex: -1,
      });
    } else if (type === "tags") {
      this.setState({
        newTag: { ...newTag, name: e.target.value },
      });
    }
  };

  addToList = () => {
    const { editListItems, newStatus, newTag } = this.state;
    const { type } = this.props;
    if (type === "status") {
      const newStr = newStatus.name;
      if (newStatus.name !== "") {
        amplitudeLogEvent(EVENTS.EVENT_NAMES.NEW_STATUS_ADDED, {
          Status: newStatus.name,
        });
      }
      if (newStr.trim() === "") {
        return editListItems;
      }
      this.setState({
        editListItems: [...editListItems, newStatus],
        newStatus: {
          name: "",
          color: "#888888",
          sequence: 100,
          localId: `${editListItems.length + 2}new-item`,
        },
      });
      return [...editListItems, newStatus];
    }
    if (type === "tags") {
      const newStr = newTag.name;
      if (newTag.name !== "") {
        amplitudeLogEvent(EVENTS.EVENT_NAMES.NEW_TAG_ADDED, {
          Tag: newTag.name,
        });
      }
      if (newStr.trim() === "") {
        return editListItems;
      }
      this.setState({
        editListItems: [...editListItems, newTag],
        newTag: {
          name: "",
          sequence: 100,
        },
      });
      return [...editListItems, newTag];
    }
    return editListItems;
  };

  _setListChanges = () => {
    const newList = this.addToList();
    this.props.applyListChanges(newList).then(res => {
      this.setState({
        editListItems: res,
      });
    });
  };

  render() {
    const { showMenu, id, type, className } = this.props;
    const { editListItems, newStatus, newTag } = this.state;
    let newItem = newTag;
    if (type === "status") {
      newItem = newStatus;
    }
    return (
      <div
        id={id}
        ref={this.setWrapperRef}
        className={`addeditdropdown-container ${className} dropdowncontainer-menu ${
          showMenu ? "show-dropdown-menu" : ""
        } add-edit-container`}>
        <ul
          onDragOver={this.dragOver}
          className="addeditdropdown-list dropdowncontainer-list">
          {editListItems &&
            editListItems.map((item, index) => (
              <li
                key={`add-edit-${item.id || item.localId}-${type}`}
                className="addeditdropdown-listitem-container"
                data-id={index}
                draggable="true"
                onDragStart={this.dragStart}
                onDragEnd={this.dragEnd}>
                <span data-id={index} className="dropdowncontainer-list-handle">
                  <FontAwesomeIcon
                    data-id={index}
                    draggable="true"
                    onDragStart={this.dragStart}
                    onDragEnd={this.dragEnd}
                    icon={["far", "bars"]}
                    className="addeditdropdown-drag-icon dropdown-add-edit-action-icons"
                  />
                </span>
                <div className="dropdown-add-edit-bg">
                  {type === "status" ? (
                    <div
                      style={{
                        backgroundColor: item.color,
                      }}
                      className="status-color-container"
                    />
                  ) : null}
                  <div className="add-edit-list-input">
                    <input
                      type="text"
                      value={item.name}
                      onChange={event => this.handleItemEdit(event, index)}
                      onFocus={() => {
                        this.handleColorIndex(index);
                      }}
                      className="dropdown-input-field"
                      data-test="addeditdropdown-edit-input"
                    />
                  </div>
                </div>
                <span className="dropdowncontainer-list-delete">
                  <FontAwesomeIcon
                    icon={["far", "trash-alt"]}
                    onClick={() => this.removeItem(index)}
                    className="addeditdropdown-delete-icon dropdown-add-edit-action-icons"
                  />
                </span>
              </li>
            ))}
          <li className="dropdowncontainer-list-addnew">
            <div
              className={`addeditdropdown-add-inputbox ${className}-inputbox dropdown-add-edit-bg add-edit-new-input`}>
              {type === "status" ? (
                <div
                  style={{
                    backgroundColor: newItem.color,
                  }}
                  className="status-color-container addeditdropdown-status-color"
                />
              ) : null}
              <input
                type="text"
                value={newItem.name}
                onChange={this.handleNewItemNameChange}
                className="dropdown-input-field"
                placeholder="Add New"
                onKeyPress={this.keyPressed}
                onFocus={() => {
                  this.handleColorIndex(-1);
                }}
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
                data-test="addeditdropdown-add-new-input"
              />
            </div>
          </li>
          {type === "status" ? (
            <div className="status-color-pallete">
              {COLORS &&
                COLORS.map(clr => (
                  <div
                    key={clr}
                    onClick={() => this.handleChangeColor(clr)}
                    role="button"
                    tabIndex="0"
                    onKeyPress={() => {}}
                    style={{
                      backgroundColor: clr,
                    }}
                    className={`status-color-container ${
                      clr === newItem.color ? "active" : ""
                    } `}
                  />
                ))}
            </div>
          ) : null}
        </ul>
        <div
          onClick={this._setListChanges}
          role="button"
          tabIndex="0"
          onKeyPress={() => {}}
          className="addeditdropdown-apply-section add-edit-item add-edit-new-input">
          <FontAwesomeIcon icon={["far", "check"]} />
          &ensp;Done
        </div>
      </div>
    );
  }
}

AddEditDropdown.propTypes = {
  id: PropTypes.string.isRequired,
  showMenu: PropTypes.bool.isRequired,
  closeAddEditContainer: PropTypes.func.isRequired,
  applyListChanges: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

const mapDispatchToProps = {
  deleteAssetStatus: deleteAssetStatusAction,
  deleteAssetTag: deleteAssetTagAction,
};

export default connect(
  null,
  mapDispatchToProps,
)(AddEditDropdown);



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/DropdownContainer/AddEditDropdown.js